module.exports = __webpack_public_path__ + "img/2.27b1fd1d.jpg";